var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/Version.ts";
import * as t from 'io-ts';
import { Id } from './Id';
export var Version = t.number;
export var VersionData;

(function (_VersionData) {
  var io = _VersionData.io = t.type({
    id: Id,
    version: Version,
    createdDate: t.string,
    name: t.union([t.string, t["null"]]),
    nameOwner: t.union([t.string, t["null"]])
  }, 'VersionData');
})(VersionData || (VersionData = {}));

export var VersionDates;

(function (_VersionDates) {
  var io = _VersionDates.io = t.type({
    versionDates: t.array(t.string)
  }, 'VersionDates');
})(VersionDates || (VersionDates = {}));

export var Versions;

(function (_Versions) {
  var io = _Versions.io = t.type({
    versions: t.array(VersionData.io)
  }, 'VersionData');
})(Versions || (Versions = {}));

export var VersionStatus = t.union([t.literal('DRAFT'), t.literal('PUBLISHED')]);